<template>
  <div
      :class="[
      'wz-overlay-wrapper',
      { 'has-stats': params.options.stats.visible }
    ]"
  >
    <div
        v-if="params.options.stats.value && params.options.stats.visible"
        class="statsname-wrapper"
    >
      <div
          class="statsname"
          :style="params.styles.user"
      >
        {{ params.options.stats.value }}
      </div>
    </div>
    <div
        v-if="params.data.user.name && params.options.user.visible"
        class="username-wrapper"
    >
      <div
          class="username"
          :style="params.styles.user"
      >
        {{ params.data.user.name }}
      </div>
    </div>
    <div
        v-if="params"
        :class="['wz-overlay', {'has-avatar': params.data.user.avatar}]"
        :style="{
        ...params.styles.overlay,
        borderRadius: `${params.styles.overlay.borderRadius}px`,
        borderWidth: `${params.styles.overlay.borderWidth}px`,
      }"
    >
      <div
          v-if="params.data.user.avatar"
          class="overlay-avatar"
      >
        <img
            :style="{borderRadius: `calc(${params.styles.overlay.borderRadius}px/2)`}"
            :src="params.data.user.avatar"
            alt=""
        >
      </div>
      <div class="wz-overlay-section">
        <div class="wz-overlay-section__value">
          {{ set1.value }}
        </div>
        <div class="wz-overlay-section__label">
          {{ set1.label }}
        </div>
      </div>
      <div class="wz-overlay-section">
        <div class="wz-overlay-section__value">
          {{ set2.value }}
        </div>
        <div class="wz-overlay-section__label">
          {{ set2.label }}
        </div>
      </div>
      <div class="wz-overlay-section">
        <div class="wz-overlay-section__value">
          {{ set3.value }}
        </div>
        <div class="wz-overlay-section__label">
          {{ set3.label }}
        </div>
      </div>

      <div
          class="frame"
          :style="{ ...params.styles.slider}"
      >
        <div
            class="frame-slide"
        >
          <div class="slide slide-1">
            <div class="logo-text">
              WZHUB.GG
            </div>
          </div>
          <div class="slide slide-2">
            <div class="main-text">
              <span>{{ set4.label }}</span> {{ set4.value }}
            </div>
            <div class="bottom-text">
              LAST {{ set6.value }} GAMES
            </div>
          </div>
          <div class="slide slide-3">
            <div class="main-text">
              <span>{{ set5.label }}</span> {{ set5.value }}%
            </div>
            <div class="bottom-text">
              LAST {{ set6.value }} GAMES
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WZOverlay',

  props: {
    params: {
      type: Object,
      default: null,
    },
  },

  computed: {
    set1() {
      return {
        label: this.params.options.sets.set1.label,
        value: this.params.data[this.params.options.sets.set1.value],
      };
    },

    set2() {
      return {
        label: this.params.options.sets.set2.label,
        value: this.params.data[this.params.options.sets.set2.value],
      };
    },

    set3() {
      return {
        label: this.params.options.sets.set3.label,
        value: this.params.data[this.params.options.sets.set3.value],
      };
    },

    set4() {
      return {
        label: this.params.options.sets?.set4.label,
        value: this.params?.data[this.params.options.sets.set4.value],
      };
    },

    set5() {
      return {
        label: this.params.options.sets?.set5.label,
        value: this.params?.data[this.params.options.sets.set5.value],
      };
    },
    set6() {
      return {
        label: this.params.options.sets?.set6.label,
        value: this.params?.data[this.params.options.sets.set6.value],
      };
    },
  },

  mounted() {
    const ml4 = {};
    ml4.opacityIn = [0, 1];
    ml4.scaleIn = [0.2, 1];
    ml4.scaleOut = 3;
    ml4.durationIn = 800;
    ml4.durationOut = 600;
    ml4.delay = 5000;

    this
      .$anime
      .timeline({
        loop: true,
      })
      .add({
        targets: '.frame',
        keyframes: [
          { translateX: -300, duration: 500 },
        ],
        easing: 'easeOutElastic(1, .8)',
        delay: ml4.delay,
      })
      .add({
        targets: '.frame .slide-1',
        opacity: ml4.opacityIn,
        scale: ml4.scaleIn,
        duration: ml4.durationIn,
      })
      .add({
        targets: '.frame .slide-1',
        opacity: 0,
        scale: ml4.scaleOut,
        duration: ml4.durationOut,
        easing: 'easeInExpo',
        delay: ml4.delay,
      })
      .add({
        targets: '.frame .slide-2',
        opacity: ml4.opacityIn,
        scale: ml4.scaleIn,
        duration: ml4.durationIn,
      })
      .add({
        targets: '.frame .slide-2',
        opacity: 0,
        scale: ml4.scaleOut,
        duration: ml4.durationOut,
        easing: 'easeInExpo',
        delay: ml4.delay,
      })
      .add({
        targets: '.frame .slide-3',
        opacity: ml4.opacityIn,
        scale: ml4.scaleIn,
        duration: ml4.durationIn,
      })
      .add({
        targets: '.frame .slide-3',
        opacity: 0,
        scale: ml4.scaleOut,
        duration: ml4.durationOut,
        easing: 'easeInExpo',
        delay: ml4.delay,
      })
      .add({
        targets: '.frame',
        keyframes: [
          { translateX: 300, duration: 500 },
        ],
        easing: 'linear',
      });
  },
};
</script>

<style lang="scss">

.wz-overlay-wrapper {
  position: relative;
  display: inline-flex;

  .statsname-wrapper {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    .statsname {
      border-radius: 10px;
      background: #000;
      padding: 5px 20px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
    }
  }

  &.has-stats {
    padding-top: 10px;

    .statsname-wrapper {
      top: 0;
    }
  }

  .username-wrapper {
    position: absolute;
    bottom: -10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    .username {
      border-radius: 10px;
      background: #000;
      padding: 5px 20px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
    }
  }
}

.wz-overlay {
  box-sizing: border-box;
  min-width: 350px;
  width: 350px;
  height: 84px;
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  padding: 0 10px;
  background: #1d1d1d;
  border: 0px #fff solid;
  overflow: hidden;

  &.has-avatar {
    min-width: 420px;
    width: 420px;
    grid-template-columns: 70px repeat(3, 1fr);

    .frame {
      width: 60%;
    }
  }

  .overlay-avatar {
    width: 60px;
    height: 60px;
    line-height: 0;

    > img {
      width: 60px;
      height: 60px;
      line-height: 0;
    }
  }

  &-section {
    font-weight: 600;
    font-size: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__label {
      text-transform: uppercase;
      margin-top: 5px;
      font-size: 12px;
    }
  }

  .frame {
    position: absolute;
    height: 100%;
    top: 0;
    right: -330px;
    width: 72%;

    &:before {
      position: absolute;
      content: "";
      width: 71.1%;
      height: 100%;
      transform-origin: 0 100%;
      transform: skew(-15deg);
      background: inherit;
      z-index: -1;
      left: -26px;
    }

    .frame-slide {
      position: absolute;
      top: 0;
      bottom: 0;
      left: -10px;
      right: 35px;
      height: 100%;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;

      .slide {
        position: absolute;
        left: 20px;
        top: 0;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 22px;
        font-weight: 600;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .logo-text {
        font-size: 30px;
      }

      .main-text {
        font-size: 24px;

        span {
          color: #fff;
          font-size: 20px;
          margin-right: 5px;
        }
      }

      .bottom-text {
        font-size: 14px;
        opacity: 0.8;
        margin-top: 5px;
      }
    }
  }

}
</style>
